<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
    <span style="color: #303133; font-size: 16px"
      >“工单记录” 模块与 “更多信息” 模块的位置已对调
    </span>
    <span style="display: none">{{ getDialogVisible() }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
      <el-button type="primary" @click="handleClose()">不再提示</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from "plus/api";

export default {
  data() {
    return {
      dialogVisible: false,
      init: false,
    };
  },
  created() {
    getDialogVisible();
  },
  methods: {
    async getDialogVisible() {
      // if (this.init === false) {
      //   const res = await api.work.currExtendParam();
      //   this.dialogVisible = res.data.data ? false : true;
      //   this.init = true;
      // }
    },
    async handleClose() {
      const res = await api.work.updateCurrExtendParam({
        extendParam: "不再提示",
      });
      this.dialogVisible = false;
    },
  },
};
</script>
